import React, { useState, useEffect } from 'react';
import './HomeMap.css'; // Import your CSS file
import bulgariaImage from '../assets/bulgaria2.png'; // Import the image
import { useNavigate } from 'react-router-dom';
import GameContentProvider from '../providers/GameContentProvider';
import { useTranslation } from 'react-i18next';
import { IS_TESTING_CAMPAIGN } from '../config'; // Adjust path if needed

const HomeMap = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [availableCities, setAvailableCities] = useState([]);

    useEffect(() => {
        const fetchAvailableCities = async () => {
            try {
                const gameContentProvider = new GameContentProvider();
                const cities = await gameContentProvider.getAvailableCities();
                setAvailableCities(cities);
            } catch (error) {
                console.error('Error fetching available cities:', error);
            }
        };

        fetchAvailableCities();
    }, []);

    const handleClick = (cityName) => {
        const data = { city: cityName };
        navigate("/games", { state: data });
    };

    const [imageSize, setImageSize] = useState({ width: 0, height: 0 });

    const handleImageLoad = (e) => {
        const img = e.target;
        // Get the real width and height of the map image (natural size)
        setImageSize({
            width: img.naturalWidth,
            height: img.naturalHeight,
        });
    };

    const getShapeStyle = (xPercent, yPercent) => {
        // Convert percentage positions to pixel positions based on the current image size
        return {
            left: `${xPercent}%`,
            top: `${yPercent}%`,
            transform: 'translate(-50%, -50%)', // Center the shapes on their exact position
        };
    };

    return (
        <div className="home-map-container">
            <div className="home-header">
                <h2 className="welcome-title">{t('welcome')}</h2>
                <p className="welcome-subtitle">{t('chose_location')}</p>
        
                <div className="centered-image-container">
                    <img
                        src={bulgariaImage}
                        alt="Bulgaria Map"
                        className="map-image"
                        onLoad={handleImageLoad}
                    />
                    {Array.isArray(availableCities) && availableCities.includes('sofia') && (
                        <div
                            className="shape sofia"
                            style={getShapeStyle(19, 42)}
                            onClick={() => handleClick('Sofia')}
                        >
                            <span className="text">{t('sofia')}</span>
                        </div>
                    )}
                    {Array.isArray(availableCities) && availableCities.includes('plovdiv') && (
                        <div
                            className="shape plovdiv"
                            style={getShapeStyle(42, 55)}
                            onClick={() => handleClick('Plovdiv')}
                        >
                            <span className="text">{t('plovdiv')}</span>
                        </div>
                    )}
                    {Array.isArray(availableCities) && availableCities.includes('varna') && (
                        <div
                            className="shape varna"
                            style={getShapeStyle(88, 32)}
                            onClick={() => handleClick('Varna')}
                        >
                            <span className="text">{t('varna')}</span>
                        </div>
                    )}
                    {Array.isArray(availableCities) && availableCities.includes('burgas') && (
                        <div
                            className="shape burgas"
                            style={getShapeStyle(50, 80)}
                            onClick={() => handleClick('Burgas')}
                        >
                            <span className="text">{t('burgas')}</span>
                        </div>
                    )}
                </div>
            </div>
    
            {/* Footer */}
            {/* <footer className="footer">
                <div className="footer-content">
                    <a href="/contacts" className="footer-link">Contacts</a>
                    <span className="footer-separator">|</span>
                    <a href="/terms-and-conditions" className="footer-link">Terms & Conditions</a>
                </div>
            </footer>*/}
            {IS_TESTING_CAMPAIGN && (
            <footer className="footer-test">
    <div className="footer-content-test">
        <a href="/testing-compaing" className="footer-link-test">
            {t('testing-compaing-start')}
            <span className="attention-grabber">{t('testing-compaing-free')}</span>
            {t('testing-compaing-end')}
        </a>
    </div>
</footer>)}
        </div>
    );
    
    
    
};

export default HomeMap;
